<template>
    <b-row>
        <b-col lg="4">
            <templates-list :is-busy="busy.active">
                <b-button slot="toolbar" :disabled="busy.active" variant="success" size="sm" @click.prevent="addNew">
                    <i class="icon-plus2"></i> {{$t('email_templates.add_template')}}
                </b-button>
            </templates-list>
        </b-col>
        <b-col lg="8">
            <template-modal v-model="showModal"/>
        </b-col>
    </b-row>
</template>

<script>

import store from "../store/store";
import {FETCH_IDENTIFIERS, FETCH_TEMPLATES} from "../store/types";
import TemplateModal from "../components/TemplateModal";
import TemplatesList from "../components/TemplatesList";

export default {
    name: "Templates",
    beforeRouteEnter: async (to, from, next) => {
        await store.dispatch(FETCH_IDENTIFIERS);
        next();
    },
    components: {
        TemplateModal, TemplatesList
    },
    mounted() {
        this.fetch()
    },
    computed: {
        ...store.mapFields(['activeTemplateUuid']),
    },
    watch: {
        activeTemplateUuid() {
            this.showModal = true;
        }
    },
    methods: {
        addNew() {
            this.showModal = true;
            this.activeTemplateUuid = null;
        },
        fetch() {
            this.busy.active = true;
            store.dispatch(FETCH_TEMPLATES)
                .finally(() => this.busy.active = false)
        }
    },

    data: () => ({
        showModal: false,
        busy: {
            active: false,
            message: ''
        },
    })
}
</script>
